import Inputmask from 'inputmask'

import {
  resetABNLookupResults,
  resetSelectedBusinessDetails,
} from '../components/application-form/helpers'
import { fetchBusinessNumber } from '../components/application-form/business-lookup/fetch-business-number'

export function ApplicationFormInputMasks(ABNLookupElements) {
  /**
   * Medicare Input Mask
   * Function to check the validation of Australian Medicare Cards
   * Resources: https://clearwater.com.au/code/medicare
   * Resources: https://stackoverflow.com/a/15823818/7101990
   * Resources: https://stackoverflow.com/a/52324373/7101990
   */
  const medicareFieldMask = document.getElementById(`medicare_card_number_mask`)

  medicareFieldMask.addEventListener(`keyup`, applyMedicareChange)
  medicareFieldMask.addEventListener(`change`, applyMedicareChange)

  function applyMedicareChange(event) {
    const medicareHiddenField = document.getElementsByName(`medicare_card_number`)

    let value = event.target.value.replace(/\D/g,``).toString()
    medicareHiddenField[0].value = value
    if (value.length === 10) {
      value = `${value.substring(0,4)} ${value.substring(4,9)} ${value.substring(9)}`
    } else if (value.length > 4) {
      value = `${value.substring(0,4)} ${value.substring(4)}`
    }
    event.target.value = value
  }

  /**
   * Drivers Licence Validation
   */
  const driversLicencePattern = new Inputmask(`**********`, {
    placeholder: ``,
  })
  const driversLicenceField = document.getElementsByName(
    `drivers_licence_number`
  )
  driversLicencePattern.mask(driversLicenceField[0])
}

export function businessNumberLookupInputMasks(ABNLookupElements) {
  /**
   * New Checkbox for the ABN Lookup
   * We need to set the value of the input field
   */
  const abnConsentCheckbox = document.getElementById(
    `commercial_purposes_accepted`
  )
  abnConsentCheckbox.addEventListener(`change`, function() {
    if (this.checked) {
      this.value = `true`
    } else {
      this.value = `false`
    }
  })

  /**
   * ABN Number and Text Search Fields
   */
  const abnNumberPattern = new Inputmask(`99999999999999`, {
    placeholder: ``,
    oncleared() {
      resetABNLookupResults()
      resetSelectedBusinessDetails()
    },
    onBeforePaste(pastedValue) {
      /**
       * Remove Spaces from pasted query
       */
      let processedQuery = pastedValue
      processedQuery = processedQuery.replace(/\s+/g, ``)
      fetchBusinessNumber(processedQuery, ABNLookupElements, `number`)
    },
  })

  const abnTextSearchPattern = new Inputmask({
    placeholder: ``,
    regex: `[A-Za-z0-9 \\&-']*`,
    oncleared() {
      resetABNLookupResults()
      resetSelectedBusinessDetails()
    },
  })
  const abnTextField = document.getElementById(`ABNTextSearchInput`)
  const abnNumberField = document.getElementById(`ABNFinder`)
  abnTextSearchPattern.mask(abnTextField)
  abnNumberPattern.mask(abnNumberField)
}
